import { VisibilityStates } from '@racemap/utilities/consts/events';
import { isArchivedEvent, isNotActivatedEvent } from '@racemap/utilities/functions/event';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { Immutable } from 'immer';
import { useStore } from '../../../store/reducers';
import { EventList } from '../../EventList';

export function StageEventList() {
  const events = useStore((s) => s.events.getter.childEvents());
  const { updateEvent, swapChildEvents } = useStore((s) => s.events.actions);

  const handleVisibilityToggle = async (event: Immutable<RacemapEvent>) => {
    if (isNotActivatedEvent(event) || isArchivedEvent(event)) return;

    const newVisibility =
      event.visibility === VisibilityStates.LISTED
        ? VisibilityStates.UNLISTED
        : VisibilityStates.LISTED;

    await updateEvent(event.id, [{ key: 'visibility', newValue: newVisibility }]);
  };

  return (
    <EventList
      events={events}
      onSwapEvents={swapChildEvents}
      onVisibilityToggle={handleVisibilityToggle}
    />
  );
}
